import { render } from "./DokumenteSimpleList.pug?vue&type=template&id=e86496fc&lang=pug"
import script from "./DokumenteSimpleList.js?vue&type=script&lang=js"
export * from "./DokumenteSimpleList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__